export default (linter) => {
  linter.RULES.max_line_length.value = 5000;
  return linter;
};
